export const debugEnabled = ["DEV", "TEST"].includes(process.env.REACT_APP_BUILD_ENVIRONMENT || "") || process.env.REACT_APP_DEBUG_ENABLED === "true";

export const isProduction = process.env.REACT_APP_BUILD_ENVIRONMENT === 'PRODUCTION';
